// Vlogs.jsx
import React from "react";
import { VlogSection, VideoWrapper, Gallery, Thumbnail } from './designcss/vlogscss'

// Images for thumbnails
//import yt2mp3down from './images/vlogs-images/youtubetomp3thumb.gif'
//import printpreview from './images/vlogs-images/printpreview-load-ui-tutorial.gif'
//import qtinputoutput from './images/vlogs-images/simple-input-output-loadui.jpeg'
import dhcp from './images/vlogs-images/dhcp.webp'
import createvirt from './images/vlogs-images/createvirt.webp'
import accessfolder from './images/vlogs-images/accessfolderfrom.jpg'
import accesswindowshared from './images/vlogs-images/accesswindowsshared.webp'
import keepass2android1 from './images/vlogs-images/keepass2android.jpg'
import keepass2android2 from './images/vlogs-images/keepass2android2.jpg'
import securegmail from './images/vlogs-images/securegmail.jpg'
import howtmakeintro from './images/vlogs-images/howtomakeintro.jpg'

const thumbnails = [
  { id: "vbyzcXew-ts", src: "https://img.youtube.com/vi/vbyzcXew-ts/maxresdefault.jpg", alt: "Enable Disable Textbox" },
  { id: "DFCse7XSV80", src: "https://img.youtube.com/vi/DFCse7XSV80/maxresdefault.jpg", alt: "YouTube to MP3 Converter" },
  { id: "A92sZDqqeqI", src: "https://img.youtube.com/vi/A92sZDqqeqI/maxresdefault.jpg", alt: "Print Preview Tutorial" },
  { id: "lLxvp5jDIPI", src: "https://img.youtube.com/vi/lLxvp5jDIPI/maxresdefault.jpg", alt: "Qt Input/Output" },
  { id: "UrTL_pyYtus", src: dhcp, alt: "DHCP Tutorial" },
  { id: "-tnEc2tW_rY", src: createvirt, alt: "Create Virtual Machine" },
  { id: "2Byeshz3SBs", src: accessfolder, alt: "Access Folder" },
  { id: "Di7dg2D4cDA", src: accesswindowshared, alt: "Access Windows Shared" },
  { id: "Fszc1FJ6CKc", src: keepass2android2, alt: "Keepass Android 2" },
  { id: "6b9G7zmJd_o", src: keepass2android1, alt: "Keepass Android 1" },
  { id: "91KHu_8GRSE", src: securegmail, alt: "Secure Gmail" },
  { id: "CmyAfXqbY_U", src: howtmakeintro, alt: "How to Make Intro" },
];

const Vlogs = () => {
  const playVideo = (videoId) => {
    const iframe = document.getElementById("mainVideo");
    iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0`;
  };

  return (
    <VlogSection>
      <h1>WELCOME TO MY VLOG</h1>
      <h3>MY LATEST UPLOAD</h3>

      <VideoWrapper>
        <iframe
          id="mainVideo"
          src={`https://www.youtube.com/embed/${thumbnails[0].id}?rel=0`}
          title="YouTube video player"
          frameBorder={0}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </VideoWrapper>

      <Gallery>
        {thumbnails.map((thumb, idx) => (
          <Thumbnail
            key={idx}
            src={thumb.src}
            alt={thumb.alt}
            onClick={() => playVideo(thumb.id)}
          />
        ))}
      </Gallery>
    </VlogSection>
  );
};

export default Vlogs;
